import DropdownMenu from "components/common/DropdownMenu";
import { Family } from "../types";
import DeactivationDialog from "./DeactivationDialog";
import ReactivationDialog from "./ReactivationDialog";
import ChangePlanDialog from "./ChangePlanDialog";
import AddHoursDialog from "./AddHoursDialog";
import { useState } from "react";
import ChangeCurrentInvoice from "./ChangeCurrentInvoice";
import RematchAdvisorDialog from "./RematchAdvisorDialog";
import { FamilyStatus } from "protogen/advisors_service_pb";

export default ({ familyData }: { familyData: Family }) => {
  const [openState, setOpenState] = useState<
    | "deactivate"
    | "reactivate"
    | "change-plan"
    | "add-hours"
    | "modify-invoice"
    | "rematch"
    | null
  >(null);

  const onUpdate = () => {
    // Refresh the page.
    window.location.reload();
  };

  const options = [];
  if (
    familyData.status === FamilyStatus.ACTIVE ||
    familyData.status === FamilyStatus.PREACTIVATION ||
    familyData.status === FamilyStatus.PROSPECT
  ) {
    options.push({
      title: "Rematch",
      onClick: () => setOpenState("rematch"),
      disabled: !!familyData.endDate,
    });
  }
  if (familyData.status === FamilyStatus.ACTIVE) {
    options.push(
      ...[
        {
          title: "Add hours",
          onClick: () => setOpenState("add-hours"),
          disabled: !!familyData.endDate,
        },
        {
          title: "Change plan",
          onClick: () => setOpenState("change-plan"),
          disabled: !!familyData.endDate,
        },
        {
          title: "Deactivate family",
          onClick: () => setOpenState("deactivate"),
          disabled: !!familyData.endDate,
        },
      ],
    );
  }
  options.push({
    title: "Modify billing period",
    onClick: () => setOpenState("modify-invoice"),
  });
  if (
    familyData.status === FamilyStatus.DEACTIVATED ||
    familyData.status === FamilyStatus.DIGITAL_DEACTIVATED ||
    familyData.status === FamilyStatus.DIGITAL_DEACTIVATED_TRIAL
  ) {
    options.push({
      title: "Re-activate family",
      onClick: () => setOpenState("reactivate"),
    });
  }
  return (
    <>
      <DropdownMenu
        noIcon={true}
        buttonContent="Actions"
        dropdownIcon={true}
        options={options.sort((a, b) => a.title.localeCompare(b.title))}
      />
      <DeactivationDialog
        familyRef={familyData.ref || ""}
        open={openState === "deactivate"}
        setOpen={(o) => setOpenState((s) => (o ? s : null))}
        onUpdate={onUpdate}
      />
      <ReactivationDialog
        familyRef={familyData.ref || ""}
        open={openState === "reactivate"}
        setOpen={(o) => setOpenState((s) => (o ? s : null))}
        onUpdate={onUpdate}
      />
      <ChangePlanDialog
        familyRef={familyData.ref || ""}
        open={openState === "change-plan"}
        setOpen={(o) => setOpenState((s) => (o ? s : null))}
        onUpdate={onUpdate}
      />
      <AddHoursDialog
        familyRef={familyData.ref || ""}
        open={openState === "add-hours"}
        setOpen={(o) => setOpenState((s) => (o ? s : null))}
        onUpdate={onUpdate}
      />
      <ChangeCurrentInvoice
        familyRef={familyData.ref || ""}
        open={openState === "modify-invoice"}
        setOpen={(o) => setOpenState((s) => (o ? s : null))}
        onUpdate={onUpdate}
      />
      <RematchAdvisorDialog
        familyRef={familyData.ref || ""}
        open={openState === "rematch"}
        setOpen={(o) => setOpenState((s) => (o ? s : null))}
        onUpdate={onUpdate}
      />
    </>
  );
};
